export default __webpack_public_path__ + "static/media/olympic-bake-off-medal-bronze.dfc7295f.svg";